// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1NuyU","content":"RecentSearches_content__1d8Bw"};